<template>
    <div class="HousingAssignments">
        <div>
            <h2>{{Title}}</h2>
            <SingleMembershipEditor :fields="[{name: 'Residence.Name', title: 'NAME'}, {name: 'StartDate', title: 'PLACEMENT', callback: 'formatDate|MM/DD/YY'}, {name: 'EndDate', title: 'END', callback: 'formatDate|MM/DD/YY|N/A'}]"
                                    :field-data="FieldData"
                                    :edit-mode="EditMode"
                                    :chart-id="ChildRecordData.Id"
                                    select-label="Location"
                                    options-type="API"
                                    :options-method="OptionsMethod"
                                    :options-method-record-id="ChildRecordData.SubProgramID"
                                    :add-record-method="AddMethod"
                                    add-record-record-property-name="ResidenceID"
                                    :add-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                    add-record-modal-title="Add Housing Assignement"
                                    :transfer-record-method="TransferMethod"
                                    transfer-record-record-property-name="ResidenceID"
                                    :transfer-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                    transfer-record-modal-title="Transfer Placement"
                                    transfer-record-effective-date-property-name="StartDate"
                                    :delete-record-method="DeleteMethod"
                                    :delete-record-additional-payload="{Id: ChildRecordData.Id}"
                                    delete-record-modal-title="Delete Current Placement"
                                    delete-record-modal-text="NOTICE: You are about to delete this client's current placement.  If there was a previous placement, it will re-open that placement." />
        </div>

    </div>

</template>

    <script>
        import SingleMembershipEditor from './SingleMembershipEditor.vue'
        //import { EventBus } from '../../../services/event-bus.js';


        export default {
            created() {

            },
            props: [
                "ChildRecordData",
                "Title",
                "AddMethod",
                "OptionsMethod",
                "TransferMethod",
                "DeleteMethod",
                "FieldData",
                "EditMode"
            ],
            data: function () {
                return {
                    ChartRecords: [],
                }
            },
            methods: {
                formatDate(value, fmt = 'D MMM YYYY') {
                    return (value == null)
                        ? ''
                        : moment(value, 'YYYY-MM-DD').format(fmt)
                },
                UpdateEditMode() {
                    this.EditMode = !this.EditMode;
                },
                CheckPermission(permissionName) {
                    return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
                },
            },
            components: {
                SingleMembershipEditor
            },
            computed: {

            },
            mounted: function () {
            }
        }
    </script>

    <style scoped>
        /deep/ .row-chapter {
            border-style: solid;
            background-color: #94a545;
            color: #fff;
            text-transform: uppercase;
            border-color: black;
            cursor: pointer;
            font-size: large;
            font-weight: bold;
        }


        .horizontal-icons-padded span {
            padding-right: 20px;
        }

        table {
            table-layout: fixed;
        }

        /deep/ .chapter-header {
            font-size: x-large;
        }

        /deep/ .right-aligned {
            text-align: right;
        }
    </style>
